var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValueFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7969,
    width: 57.1404,
    height: 57.1404,
    rx: 15,
    transform: "rotate(15 14.7969 0)",
    fill: "#4060EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_285_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 57,
    height: 57,
    rx: 15,
    fill: "white",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7425 52.416C17.4412 52.416 16.2572 52.1173 15.1905 51.52C14.1238 50.912 13.2012 50.0747 12.4225 49.008C11.6545 47.9413 11.0625 46.7093 10.6465 45.312C10.2305 43.904 10.0225 42.4 10.0225 40.8C10.0225 39.2 10.2305 37.7013 10.6465 36.304C11.0625 34.896 11.6545 33.6587 12.4225 32.592C13.2012 31.5253 14.1238 30.6933 15.1905 30.096C16.2572 29.488 17.4412 29.184 18.7425 29.184C20.0438 29.184 21.2278 29.488 22.2945 30.096C23.3612 30.6933 24.2732 31.5253 25.0305 32.592C25.7985 33.6587 26.3905 34.896 26.8065 36.304C27.2332 37.7013 27.4465 39.2 27.4465 40.8C27.4465 42.4 27.2332 43.904 26.8065 45.312C26.3905 46.7093 25.7985 47.9413 25.0305 49.008C24.2732 50.0747 23.3612 50.912 22.2945 51.52C21.2278 52.1173 20.0438 52.416 18.7425 52.416ZM18.7425 48.512C19.8838 48.512 20.8278 48.1493 21.5745 47.424C22.3212 46.6987 22.8758 45.7493 23.2385 44.576C23.6012 43.4027 23.7825 42.144 23.7825 40.8C23.7825 39.3813 23.5905 38.0907 23.2065 36.928C22.8225 35.7547 22.2572 34.8213 21.5105 34.128C20.7638 33.4347 19.8412 33.088 18.7425 33.088C17.8785 33.088 17.1265 33.3013 16.4865 33.728C15.8572 34.144 15.3345 34.7147 14.9185 35.44C14.5025 36.1653 14.1932 36.992 13.9905 37.92C13.7878 38.8373 13.6865 39.7973 13.6865 40.8C13.6865 42.1333 13.8678 43.392 14.2305 44.576C14.6038 45.7493 15.1638 46.6987 15.9105 47.424C16.6678 48.1493 17.6118 48.512 18.7425 48.512ZM39.2223 52V46.576H29.6863V42.656L38.3103 29.6H43.1263V42.672H45.0143V46.576H43.1263V52H39.2223ZM34.2143 42.656L39.2223 42.672L39.2063 34.928L34.2143 42.656Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_285_11",
    x: -24,
    y: -11,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_285_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_285_11",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueFour);
export default __webpack_public_path__ + "static/media/ValueFour.a0147bfd42044c2ec1c2e4b81d21e919.svg";
export { ForwardRef as ReactComponent };